/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{ForwardLinearDepth as o}from"./ForwardLinearDepth.glsl.js";import{isColor as r}from"./ShaderOutput.js";import{If as e,glsl as t}from"../shaderModules/glsl.js";function a(a,d){const i=r(d.output)&&d.receiveShadows;i&&o(a,!0),a.vertex.code.add(t`
    void forwardLinearDepthToReadShadowMap() { ${e(i,"forwardLinearDepth(gl_Position.w);")} }
  `)}export{a as ForwardLinearDepthToReadShadowMap};
